/* ===========================================================================
   assets/sdo-profil-local.js — Profil olfactif local (navigateur)
   © 2026 Lohan Vlaminck — Numerigram
   ---------------------------------------------------------------------------
   Deux rôles, un seul fichier, aucun appel réseau dans les deux cas.

   1. SUR UNE FICHE PRODUIT : relève la ou les familles olfactives du parfum
      consulté et les cumule dans localStorage. Rien d'identifiant n'est
      stocké : des noms de familles, des handles publics, un compteur.

   2. SUR UNE PAGE PORTANT UN CARROUSEL : réordonne les fiches DÉJÀ RENDUES
      pour remonter celles qui correspondent aux familles cumulées. Aucune
      carte n'est ajoutée ni retirée, aucune requête n'est émise, et la
      mutation du DOM tient en une seule frame. Donc pas de décalage de mise
      en page, et une charge négligeable sur le fil principal — le point
      sensible du site étant l'INP mobile.

   Le carrousel reste correct si ce fichier ne s'exécute jamais : il affiche
   alors la liste par défaut, dans l'ordre de la collection.
   =========================================================================== */
(function () {
  'use strict';

  var CLE = 'sdo_profil_v1';
  var DUREE_MS = 120 * 24 * 60 * 60 * 1000; // 120 jours
  var MAX_HANDLES = 15;
  var MAX_PAR_FAMILLE = 20;
  var MAX_FAMILLES = 12;

  /* -------------------------------------------------------------------------
     Consentement. La boutique affiche une bannière ; on ne dépose donc rien
     tant que la catégorie « préférences » n'est pas accordée. Si l'API n'est
     pas là (page hors boutique, script chargé trop tôt), on s'abstient aussi :
     mieux vaut un carrousel par défaut qu'un dépôt non consenti.
  ------------------------------------------------------------------------- */
  function consentementAccorde() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.preferencesProcessingAllowed !== 'function') return false;
      return cp.preferencesProcessingAllowed() === true;
    } catch (e) {
      return false;
    }
  }

  /* -------------------------------------------------------------------------
     Accès au stockage. Tout est sous try/catch : en navigation privée, avec
     les cookies tiers bloqués ou un quota plein, localStorage JETTE au lieu
     de renvoyer null. Une exception non rattrapée ici ferait tomber le reste
     du fichier, donc le réordonnancement avec.
  ------------------------------------------------------------------------- */
  function lire() {
    try {
      var brut = window.localStorage.getItem(CLE);
      if (!brut) return null;
      var o = JSON.parse(brut);
      if (!o || typeof o !== 'object') return null;
      if (!o.t || Date.now() - o.t > DUREE_MS) return null;
      if (!o.f || typeof o.f !== 'object') return null;
      return o;
    } catch (e) {
      return null;
    }
  }

  function ecrire(o) {
    try {
      window.localStorage.setItem(CLE, JSON.stringify(o));
    } catch (e) {
      /* quota, mode privé : on abandonne en silence */
    }
  }

  /* -------------------------------------------------------------------------
     1. Relevé sur la fiche produit
  ------------------------------------------------------------------------- */
  function releverProduitCourant() {
    var balise = document.getElementById('sdo-produit-courant');
    if (!balise) return;

    var donnees;
    try {
      donnees = JSON.parse(balise.textContent || '{}');
    } catch (e) {
      return;
    }
    if (!donnees || !donnees.handle) return;

    var familles = donnees.familles;
    if (typeof familles === 'string') familles = familles ? familles.split('|') : [];
    if (!Array.isArray(familles)) familles = [];

    var etat = lire() || { f: {}, v: [], t: Date.now() };

    // Une même fiche revue dix fois ne doit pas écraser le reste du profil.
    if (etat.v.indexOf(donnees.handle) === -1) {
      for (var i = 0; i < familles.length; i++) {
        var nom = String(familles[i]).trim();
        if (!nom) continue;
        var actuel = etat.f[nom] || 0;
        if (actuel < MAX_PAR_FAMILLE) etat.f[nom] = actuel + 1;
      }
      etat.v.unshift(donnees.handle);
      if (etat.v.length > MAX_HANDLES) etat.v.length = MAX_HANDLES;
    }

    // Bornage du nombre de familles retenues : on garde les plus fréquentes.
    var noms = Object.keys(etat.f);
    if (noms.length > MAX_FAMILLES) {
      noms.sort(function (a, b) { return etat.f[b] - etat.f[a]; });
      var reduit = {};
      for (var j = 0; j < MAX_FAMILLES; j++) reduit[noms[j]] = etat.f[noms[j]];
      etat.f = reduit;
    }

    etat.t = Date.now();
    ecrire(etat);
  }

  /* -------------------------------------------------------------------------
     2. Réordonnancement du carrousel

     Tri STABLE : à score égal, l'ordre de la collection est conservé. C'est
     ce qui fait qu'un visiteur sans historique voit exactement la liste
     choisie dans l'éditeur, dans son ordre, et pas une permutation
     arbitraire. Array.prototype.sort est stable depuis ES2019 ; on ne s'y
     fie pas et on trie sur un index de secours.
  ------------------------------------------------------------------------- */
  function reordonner(piste, etat) {
    var items = Array.prototype.slice.call(piste.children);
    if (items.length < 2) return false;

    var note = [];
    var meilleur = 0;

    /* Les délais d'animation sont portés par les éléments eux-mêmes
       (style="animation-delay: 0.24s"), comme dans featured-collection. Après
       permutation, l'apparition en cascade partirait dans le désordre. On
       relève donc les délais dans l'ordre d'affichage pour les réattribuer
       ensuite par POSITION et non par élément. */
    var delais = [];
    for (var d = 0; d < items.length; d++) {
      delais.push(items[d].style ? items[d].style.animationDelay : '');
    }

    for (var i = 0; i < items.length; i++) {
      var attr = items[i].getAttribute('data-sdo-familles') || '';
      var fams = attr ? attr.split('|') : [];
      var score = 0;
      for (var k = 0; k < fams.length; k++) {
        var nom = fams[k].trim();
        if (nom && etat.f[nom]) score += etat.f[nom];
      }
      if (score > meilleur) meilleur = score;
      note.push({ el: items[i], score: score, rang: i });
    }

    // Aucune correspondance : on ne touche à rien et on n'affiche aucune
    // mention de personnalisation.
    if (meilleur === 0) return false;

    note.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return a.rang - b.rang;
    });

    // L'ordre est-il seulement différent ? Si non, inutile de toucher au DOM.
    var change = false;
    for (var m = 0; m < note.length; m++) {
      if (note[m].rang !== m) { change = true; break; }
    }
    if (!change) return false;

    var frag = document.createDocumentFragment();
    for (var n = 0; n < note.length; n++) {
      if (note[n].el.style && delais[n]) note[n].el.style.animationDelay = delais[n];
      frag.appendChild(note[n].el);
    }
    piste.appendChild(frag);

    return true;
  }

  function traiterCarrousels() {
    var pistes = document.querySelectorAll('[data-sdo-piste]');
    if (!pistes.length) return;

    var etat = lire();
    if (!etat) return;

    for (var i = 0; i < pistes.length; i++) {
      var piste = pistes[i];

      // L'étage serveur a déjà fait mieux : on le laisse tranquille.
      if (piste.getAttribute('data-sdo-origine') === 'profil') continue;

      if (reordonner(piste, etat)) {
        var section = piste.closest ? piste.closest('.sdo-carrousel') : null;
        var note = section ? section.querySelector('[data-sdo-note]') : null;
        if (note) note.hidden = false;
      }
    }
  }

  /* -------------------------------------------------------------------------
     Attente de l'API de consentement.

     CONSTATÉ EN PROD le 13/09/2026 : window.Shopify.customerPrivacy n'existe
     PAS encore au moment où ce script s'exécute, alors qu'elle est bien là
     deux secondes plus tard avec le consentement accordé. Shopify la charge
     de façon asynchrone. Une vérification unique au démarrage répondait donc
     « non consenti » à un visiteur parfaitement consentant, et RIEN n'était
     jamais relevé.

     On réessaie donc jusqu'à ce que l'API apparaisse, et on s'arrête dès
     qu'elle a tranché — accord comme refus. Cinq secondes au plus, par pas
     de 250 ms, sur une page produit uniquement.
  ------------------------------------------------------------------------- */
  function tenterReleve(essaisRestants) {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    var apiPrete = !!(cp && typeof cp.preferencesProcessingAllowed === 'function');

    if (apiPrete) {
      if (consentementAccorde()) releverProduitCourant();
      return;
    }
    if (essaisRestants > 0) {
      window.setTimeout(function () { tenterReleve(essaisRestants - 1); }, 250);
    }
  }

  function demarrer() {
    // Le réordonnancement d'abord : il ne lit que ce qui a déjà été déposé,
    // il n'a donc aucune raison d'attendre l'API de consentement.
    traiterCarrousels();

    if (document.getElementById('sdo-produit-courant')) {
      tenterReleve(20);
    }
  }

  /* Le script est chargé en defer : le DOM est prêt. On passe tout de même
     par requestAnimationFrame pour que la lecture du stockage et la mutation
     tombent dans la même frame, hors du chemin de rendu initial. */
  if (window.requestAnimationFrame) {
    window.requestAnimationFrame(demarrer);
  } else {
    demarrer();
  }

  /* Le visiteur peut accepter la bannière APRÈS le chargement. Dans ce cas la
     fiche consultée n'aurait jamais été relevée. */
  document.addEventListener('visitorConsentCollected', function () {
    if (consentementAccorde()) releverProduitCourant();
  });
})();